<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{'Turbo.Order.ContextInformaion.lblHeader' | translate : 'Context Information'}} - {{ contextName }}">
      <t4-productprices contextId="{{ contextId }}"> </t4-productprices>
  </t4-container>
